import { useEffect, useState } from "react";

import { api_without_cancellation } from "../../../api/api";

const useGetPartyTypes = () => {
  const [partyTypes, setPartyTypes] = useState({ results: [] });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await api_without_cancellation.get("/api/otherparties/party_types/");
        if (mounted && res.status === 200) {
          const data = Array.isArray(res.data) ? { results: res.data } : res.data;
          setPartyTypes(data);
        }
      } catch (err) {
        console.error("Failed to fetch party types:", err);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return { partyTypes };
};

export default useGetPartyTypes;
